export default __webpack_public_path__ + "static/media/BrainBreak cards14.f1ab1221.png";